var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 8.70977L13.6668 4.56177C12.704 3.81274 11.3556 3.81274 10.3928 4.56177L5.05879 8.70977C4.40919 9.21494 4.0294 9.99187 4.02979 10.8148V18.0148C4.02979 19.1193 4.92522 20.0148 6.02979 20.0148H18.0298C19.1344 20.0148 20.0298 19.1193 20.0298 18.0148V10.8148C20.0298 9.99177 19.6498 9.21477 18.9998 8.70977Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 8.70977L13.6668 4.56177C12.704 3.81274 11.3556 3.81274 10.3928 4.56177L5.05879 8.70977C4.40919 9.21494 4.0294 9.99187 4.02979 10.8148V18.0148C4.02979 19.1193 4.92522 20.0148 6.02979 20.0148H18.0298C19.1344 20.0148 20.0298 19.1193 20.0298 18.0148V10.8148C20.0298 9.99177 19.6498 9.21477 18.9998 8.70977",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.0001C13.79 16.3331 10.208 16.3331 8 15.0001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7388ea0e9a6f7c5ad2e7f6e7f1b09c03.svg";
export { ForwardRef as ReactComponent };